export const BdcPaymentTypeCodes = [
  { code: 1, name: `American Express` },
  { code: 2, name: `Visa` },
  { code: 3, name: `Euro/Mastercard` },
  { code: 4, name: `Carte Bleue` },
  { code: 5, name: `Diners Club` },
  { code: 7, name: `JCB` },
  { code: 8, name: `PIN` },
  { code: 9, name: `Red 6000` },
  { code: 10, name: `Maestro` },
  { code: 11, name: `Discover` },
  { code: 12, name: `Bancontact` },
  { code: 13, name: `Solo` },
  { code: 14, name: `Switch` },
  { code: 15, name: `Carte Blanche` },
  { code: 16, name: `NICOS` },
  { code: 17, name: `UC` },
  { code: 18, name: `Cash` },
  { code: 19, name: `Bankcard` },
  { code: 21, name: `CartaSi` },
  { code: 22, name: `Argencard` },
  { code: 23, name: `Cabal` },
  { code: 25, name: `Red Compra` },
  { code: 26, name: `Other Cards` },
  { code: 27, name: `Greatwall` },
  { code: 28, name: `Peony` },
  { code: 29, name: `Dragon` },
  { code: 30, name: `Pacific` },
  { code: 31, name: `Jin Sui` },
  { code: 32, name: `Eftpos` },
  { code: 34, name: `Hipercard` },
  { code: 35, name: `UnionPay debit card` },
  { code: 37, name: `EC-Card` },
  { code: 38, name: `BC-Card` },
  { code: 39, name: `MasterCard (virtual credit card)` },
  { code: 40, name: `Mastercard Google Wallet` },
  { code: 41, name: `KH Széchényi Pihenõkártya` },
  { code: 42, name: `MKB Széchényi Pihenõkártya` },
  { code: 43, name: `OTP Széchényi Pihenõkártya` },
  { code: 44, name: `UnionPay credit card` },
  { code: 46, name: `PayPal` },
  { code: 47, name: `Cheque (domestic only)` },
  { code: 48, name: `ANCV chèques-vacances` },
  { code: 49, name: `PayPlug` },
  { code: 50, name: `Euro 6000` },
  { code: 51, name: `Postepay` },
  { code: 52, name: `Sistema 4B` },
  { code: 53, name: `PagSeguro` },
  { code: 54, name: `Elo Creditcard` },
  { code: 55, name: `Bcash` },
  { code: 56, name: `Interac e-Transfer` },
  { code: 57, name: `M-Pesa` },
  { code: 58, name: `Knet` },
  { code: 59, name: `Western Union` },
  { code: 60, name: `Apple Pay` },
  { code: 61, name: `Square Cash` },
  { code: 62, name: `iDeal` },
  { code: 63, name: `BankAxept` },
  { code: 64, name: `Reka-Check` },
  { code: 65, name: `Paysera.com` },
  { code: 66, name: `BankLink` },
  { code: 67, name: `Alipay` },
  { code: 68, name: `Tenpay` },
  { code: 69, name: `Lastschrift` },
  { code: 70, name: `Sadad` },
  { code: 71, name: `Qiwi` },
  { code: 72, name: `AirPlus` },
  { code: 73, name: `Virtual Credit Card` },
  { code: 74, name: `Visa (virtual credit card)` },
  { code: 75, name: `American Express (virtual credit card)` },
]
